import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Contact.css';
import { LuLocate, LuMailOpen, LuPhoneCall } from 'react-icons/lu';
import emailjs from '@emailjs/browser';

const INITIAL_FORM = {
  // Infos client
  nom: '', email: '', telephone: '',
  // Infos animal
  espece: '', race: '', poids: '',
  // Trajet
  depart: '', arrivee: '',
  // Mode de paiement
  modePaiement: '',
  // Message
  message: '',
};

export default function Contact({ trackEvent }) {
  const [form, setForm] = useState(INITIAL_FORM);
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [touched, setTouched] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (e) => {
    setTouched((prev) => ({ ...prev, [e.target.name]: true }));
  };

  const validate = () => {
    return form.nom && form.email && form.telephone && form.espece && form.depart && form.arrivee && form.modePaiement;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) {
      // Marquer tous les champs comme touchés pour afficher les erreurs
      const allTouched = Object.keys(INITIAL_FORM).reduce((acc, k) => ({ ...acc, [k]: true }), {});
      setTouched(allTouched);
      return;
    }

    setStatus('loading');

    // Tracking : soumission du formulaire de devis (point de tracking clé)
    trackEvent('form_submitted', {
      espece: form.espece,
      trajet: `${form.depart} → ${form.arrivee}`,
      poids: form.poids || 'non renseigné',
      modePaiement: form.modePaiement,
    });

    // envoie de mail a l'entreprise (remplacer par un vrai appel API)
    await emailjs.send(
      'service_tale1av', 
      'template_ehsd97p', 
      {
        user_name: form.nom,
        user_email: form.email,
        user_phone: form.telephone,
        espece: form.espece,
        race: form.race,
        poids: form.poids,
        depart: form.depart,
        arrive: form.arrivee,
        mode_paiement: form.modePaiement,
        message: form.message,
        date: new Date().toLocaleDateString('fr-FR', {
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }),
         
      }, 
      '_pSlw3dR4KR5uY6MQ'
    )
      .then(async () => {
        //accuser de reception envoye au client
          await emailjs.send(
            'service_tale1av', 
            'template_406s8z3', 
            {
              user_name: form.nom,
              email: form.email,
            }, 
            '_pSlw3dR4KR5uY6MQ'
          ).then(result=>{

            setStatus('success');
            setForm(INITIAL_FORM);
            setTouched({});
            console.log('Success:', result.text);
            alert("Message envoyé avec succès ! \n Nous avons bien reçu et est en cours de traitement! ");
          })
          .catch(error=>{
            setStatus('error')
            console.log('Failed:', error.text);
            alert("Une erreur s'est produite, veuillez réessayer.");
          })

      }, (error) => {
          setStatus('error')
          console.log('Failed:', error.text);
          alert("Une erreur s'est produite, veuillez réessayer.");
      });
  };

  
  const isInvalid = (field) => touched[field] && !form[field];

  return (
    <section id="contact" className="contact" data-tracking-name="Contact">
      <div className="contact-container">

        {/* Colonne info */}
        <motion.div
          className="contact-info"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7 }}
        >
          <span className="section-label">Demande de devis</span>
          <h2 className="section-title contact-title">
            Parlons du voyage<br />de votre compagnon
          </h2>
          <p className="contact-desc">
            Remplissez ce formulaire et un conseiller vous contacte sous 24h
            avec un devis personnalisé et des conseils adaptés à votre situation.
          </p>

          {/* Blocs de contact */}
          <div className="contact-meta">
            {[
              { icon: <LuPhoneCall/>, label: 'Téléphone', value: '+33 7 56 85 25 52' },
              { icon: <LuMailOpen/>, label: 'Email', value: <a href="mailto:hello@air-transport-animalier.com">hello@air-transport-animalier.com</a> },
              { icon: <LuMailOpen/>, label: 'Email2', value: <a href="mailto:transportdesanimaux@air-transport-animalier.com">transportdesanimaux@air-transport-animalier.com</a> },
              { icon: <LuLocate/>, label: 'Localisation', value: '15 quai Rauba Capéu 06300 Nice' },
            ].map((item) => (
              <div key={item.label} className="contact-meta-item">
                <span className="meta-icon">{item.icon}</span>
                <div>
                  <span className="meta-label">{item.label}</span>
                  <span className="meta-value">{item.value}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Réassurance */}
          <div className="contact-reassurance">
            
            <p>Vos données sont traitées de façon confidentielle et ne sont jamais partagées avec des tiers.</p>
          </div>
        </motion.div>

        {/* Formulaire */}
        <motion.div
          className="contact-form-wrapper"
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          {status === 'success' ? (
            <motion.div
              className="form-success"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              <span className="success-icon">✅</span>
              <h3>Demande envoyée !</h3>
              <p>Un conseiller vous contactera dans les 24 heures avec votre devis personnalisé.</p>
              <button className="btn-primary" onClick={() => setStatus('idle')}>
                Nouvelle demande
              </button>
            </motion.div>
          ) : (
            <form className="contact-form" onSubmit={handleSubmit} noValidate>

              {/* Section : Vos coordonnées */}
              <div className="form-section">
                <span className="form-section-label">
                  <span className="form-section-num">01</span>
                  Vos coordonnées
                </span>
                <div className="form-row">
                  <div className={`form-group ${isInvalid('nom') ? 'invalid' : ''}`}>
                    <label htmlFor="nom">Nom complet *</label>
                    <input
                      id="nom" name="nom" type="text"
                      placeholder="Jean Dupont"
                      value={form.nom}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {isInvalid('nom') && <span className="form-error">Champ requis</span>}
                  </div>
                  <div className={`form-group ${isInvalid('telephone') ? 'invalid' : ''}`}>
                    <label htmlFor="telephone">Téléphone *</label>
                    <input
                      id="telephone" name="telephone" type="tel"
                      placeholder="+33 6 00 00 00 00"
                      value={form.telephone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {isInvalid('telephone') && <span className="form-error">Champ requis</span>}
                  </div>
                </div>
                <div className={`form-group ${isInvalid('email') ? 'invalid' : ''}`}>
                  <label htmlFor="email">Adresse email *</label>
                  <input
                    id="email" name="email" type="email"
                    placeholder="jean@exemple.com"
                    value={form.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {isInvalid('email') && <span className="form-error">Champ requis</span>}
                </div>
              </div>

              {/* Section : Votre animal */}
              <div className="form-section">
                <span className="form-section-label">
                  <span className="form-section-num">02</span>
                  Votre animal
                </span>
                <div className="form-row">
                  <div className={`form-group ${isInvalid('espece') ? 'invalid' : ''}`}>
                    <label htmlFor="espece">Espèce *</label>
                    <select
                      id="espece" name="espece"
                      value={form.espece}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    >
                      <option value="">Sélectionner…</option>
                      <option>Chien</option>
                      <option>Chat</option>
                      <option>Oiseau</option>
                      <option>Reptile</option>
                      <option>Rongeur</option>
                      <option>Autre</option>
                    </select>
                    {isInvalid('espece') && <span className="form-error">Champ requis</span>}
                  </div>
                  <div className="form-group">
                    <label htmlFor="race">Race / Espèce précise</label>
                    <input
                      id="race" name="race" type="text"
                      placeholder="Labrador, Bengal…"
                      value={form.race}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group form-group--half">
                  <label htmlFor="poids">Poids approximatif (kg)</label>
                  <input
                    id="poids" name="poids" type="number"
                    placeholder="ex : 12"
                    min="0"
                    value={form.poids}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* Section : Trajet */}
              <div className="form-section">
                <span className="form-section-label">
                  <span className="form-section-num">03</span>
                  Le trajet
                </span>
                <div className="form-row">
                  <div className={`form-group ${isInvalid('depart') ? 'invalid' : ''}`}>
                    <label htmlFor="depart">Ville / Pays de départ *</label>
                    <input
                      id="depart" name="depart" type="text"
                      placeholder="Paris, France"
                      value={form.depart}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {isInvalid('depart') && <span className="form-error">Champ requis</span>}
                  </div>
                  <div className={`form-group ${isInvalid('arrivee') ? 'invalid' : ''}`}>
                    <label htmlFor="arrivee">Ville / Pays d'arrivée *</label>
                    <input
                      id="arrivee" name="arrivee" type="text"
                      placeholder="New York, USA"
                      value={form.arrivee}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {isInvalid('arrivee') && <span className="form-error">Champ requis</span>}
                  </div>
                </div>
              </div>

              {/* Section : Mode de paiement */}
              <div className="form-section">
                <span className="form-section-label">
                  <span className="form-section-num">04</span>
                  Mode de paiement
                </span>
                <div className={`form-group ${isInvalid('modePaiement') ? 'invalid' : ''}`}>
                  <label htmlFor="modePaiement">Mode de paiement préféré *</label>
                  <select
                    id="modePaiement" 
                    name="modePaiement"
                    value={form.modePaiement}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Sélectionner un mode de paiement…</option>
                    <option value="PaysafeCard">PaysafeCard</option>
                    <option value="virement_bancaire">Virement bancaire</option>
                  </select>
                  {isInvalid('modePaiement') && <span className="form-error">Champ requis</span>}
                </div>
              </div>

              {/* Message optionnel */}
              <div className="form-group">
                <label htmlFor="message">Informations complémentaires</label>
                <textarea
                  id="message" name="message" rows={4}
                  placeholder="Date souhaitée, besoins spécifiques, état de santé de l'animal…"
                  value={form.message}
                  onChange={handleChange}
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                className={`btn-primary form-submit ${status === 'loading' ? 'loading' : ''}`}
                disabled={status === 'loading'}
              >
                {status === 'loading' ? (
                  <>
                    <span className="spinner" />
                    Envoi en cours…
                  </>
                ) : (
                  <>Obtenir mon devis gratuit →</>
                )}
              </button>

              <p className="form-legal">
                * Champs obligatoires. Réponse garantie sous 24h ouvrées.
              </p>
            </form>
          )}
        </motion.div>
      </div>
    </section>
  );
}